export type Category = 'playable' | 'html' | 'report';

// Display order is the order shown in My Uploads sections.
export const CATEGORIES: { key: Category; label: string; section: string }[] = [
  { key: 'playable', label: 'Playable', section: 'Playables' },
  { key: 'html', label: 'HTML Page', section: 'HTML Pages' },
  { key: 'report', label: 'AI Report', section: 'AI Reports' },
];

// Derive a category for older records that predate the field.
export function resolveCategory(d: { category?: string; uploadType?: string | null }): Category {
  if (d.category === 'playable' || d.category === 'html' || d.category === 'report') return d.category;
  return d.uploadType ? 'html' : 'report';
}
